import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/icon-arrow-left.svg'
import _imports_1 from '@/app/ui/assets/svg/icon-arrow-right.svg'
import _imports_2 from '@/app/ui/assets/svg/noData_empty.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-b77f06ea")

_pushScopeId("data-v-b77f06ea")
const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "flex justify-between items-center mb-2" }
const _hoisted_3 = { class: "font-semibold text-gray-lp-300 text-base" }
const _hoisted_4 = { class: "flex gap-2" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-1.5 h.1.5 cursor-pointer",
  alt: "close-icon"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-1.5 h.1.5 cursor-pointer",
  alt: "close-icon"
}, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "w-full h-full"
}
const _hoisted_8 = { class: "w-full h-full justify-center items-center flex flex-col mx-auto text-12px xxl:text-14px overflow-hidden border-t border-gray-lp-200" }
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-32 mt-8 mx-auto",
  alt: "noData_empty"
}, null, -1)
const _hoisted_10 = { class: "text-gray-lp-300 py-2" }
const _hoisted_11 = {
  key: 1,
  ref: "scrollContainer",
  class: "flex overflow-x-auto scroll-smooth gap-4 pb-2"
}
const _hoisted_12 = { class: " flex flex-row gap-4 justify-between items-baseline h-16  bg-gradient-to-r from-red-lp-1300 to-red-lp-2300 p-2 mb-2 rounded-2xl" }
const _hoisted_13 = {
  key: 0,
  "data-testid": "cod-daily-deposit-card-amount",
  class: "text-red-lp-100 font-semibold text-base"
}
const _hoisted_14 = {
  key: 1,
  class: "text-red-lp-100 font-semibold text-base"
}
const _hoisted_15 = { class: "text-gray-lp-300 font-medium text-sm " }
const _hoisted_16 = { class: "border border-gray-lp-1400 rounded-2xl bg-white p-2 -mt-9" }
const _hoisted_17 = { class: "flex flex-row gap-2 justify-between items-baseline" }
const _hoisted_18 = { class: "text-gray-lp-300 font-semibold text-sm mb-2" }
const _hoisted_19 = { class: "flex gap-2 items-center justify-between" }
const _hoisted_20 = { class: "text-xs text-gray-500" }
const _hoisted_21 = { class: "flex gap-2 mb-2 overflow-hidden" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_PreviewImagePod = _resolveComponent("PreviewImagePod")!
  const _component_PopupDepositDetail = _resolveComponent("PopupDepositDetail")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.setoranMasuk")) + " (" + _toDisplayString(_ctx.deposits.length) + ") ", 1),
        _createVNode("div", _hoisted_4, [
          _createVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.scrollLeft && _ctx.scrollLeft(...args))),
            class: "px-2 rounded-full style-button"
          }, [
            _hoisted_5
          ]),
          _createVNode("button", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.scrollRight && _ctx.scrollRight(...args))),
            class: "px-2 rounded-full style-button"
          }, [
            _hoisted_6
          ])
        ])
      ]),
      ( _ctx.deposits.length === 0)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.noHistoryFromDriverApp")), 1)
            ])
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_11, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.deposits, (item, index) => {
              return (_openBlock(), _createBlock("div", {
                key: index,
                class: "min-w-[280px] flex-shrink-0 rounded-xl"
              }, [
                _createVNode("div", _hoisted_12, [
                  (_ctx.type == 'uang')
                    ? (_openBlock(), _createBlock("div", _hoisted_13, _toDisplayString(_ctx.formatPriceRP(item.totalAmount)), 1))
                    : (_openBlock(), _createBlock("div", _hoisted_14, _toDisplayString(item.stt.length) + " STT ", 1)),
                  _createVNode("div", _hoisted_15, _toDisplayString(_ctx.formatDateToString(item.createdAt)), 1)
                ]),
                _createVNode("div", _hoisted_16, [
                  _createVNode("div", _hoisted_17, [
                    _createVNode("div", _hoisted_18, _toDisplayString(_ctx.type == 'uang' ? item.stt.length  : item.totalPiece) + " " + _toDisplayString(_ctx.type == 'uang' ? 'STT' : _ctx.$t("codReconcile.dailyDeposit.koli")), 1),
                    _createVNode("div", _hoisted_19, [
                      _createVNode("button", {
                        class: "text-blue-lp-800 text-sm font-semibold cursor-pointer",
                        onClick: ($event: any) => (_ctx.openPopup(item))
                      }, _toDisplayString(_ctx.$t("codReconcile.detail.lihatDetail")), 9, ["onClick"]),
                      _createVNode("span", _hoisted_20, _toDisplayString(item.sttCountText || ""), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_21, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.proofUrls, (photo, i) => {
                      return (_openBlock(), _createBlock("div", {
                        key: i,
                        class: "w-16 h-16 rounded-lg overflow-hidden bg-gray-100 cursor-pointer",
                        onClick: ($event: any) => (_ctx.onPreview(item.proofUrls))
                      }, [
                        _createVNode("img", {
                          src: photo,
                          class: "object-cover w-full h-full",
                          alt: "bukti setor"
                        }, null, 8, ["src"])
                      ], 8, ["onClick"]))
                    }), 128))
                  ])
                ])
              ]))
            }), 128))
          ], 512)),
      (_ctx.isPreviewPhotos)
        ? (_openBlock(), _createBlock(_component_PreviewImagePod, {
            key: 2,
            data: _ctx.previewPhotos,
            onClose: _ctx.onClosePreview
          }, null, 8, ["data", "onClose"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_PopupDepositDetail, {
      modelValue: _ctx.showPopup,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.showPopup = $event)),
      typeDeposit: _ctx.type,
      data: _ctx.selectedDeposit
    }, null, 8, ["modelValue", "typeDeposit", "data"])
  ], 64))
})